<template>
    <index-table-row :item="item">
        <index-table-cell class="text-center">
            <md-icon v-if="item.isFederatedUser && item.federatedSsoInactive" class="text-warning">priority_high</md-icon>
            <md-icon v-else-if="item.isFederatedUser" class="text-success">check</md-icon>
            <md-icon v-else class="text-danger md-icon-clear">clear</md-icon>
        </index-table-cell>
        <index-table-cell v-text="item.firstName"/>
        <index-table-cell v-text="item.lastName"/>
        <index-table-cell v-text="item.email"/>
        <index-table-cell-bool :bool="Boolean(item.isActive)"/>
        <index-table-cell-date :date="String(item.deletedAt)"/>
        <index-table-cell>
            <user-deleted-more-dropdown :user="itemData"/>
        </index-table-cell>
    </index-table-row>
</template>

<script>
    import IndexTableRow from "../../../components/Index/IndexTableRow";
    import IndexTableCell from "../../../components/Index/IndexTableCell";
    import UserDeletedMoreDropdown from "./UserDeletedMoreDropdown";
    import IndexTableCellBool from "../../../components/Index/IndexTableCellBool";
    import IndexTableCellDate from "../../../components/Index/IndexTableCellDate";

    export default {
        name: "UsersDeletedRow",
        components: {IndexTableCellDate, IndexTableCellBool, UserDeletedMoreDropdown, IndexTableCell, IndexTableRow},
        //components: {IndexTableCellDate, IndexTableCellBool, IndexTableCell, IndexTableRow},
        props: {
            item: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                itemData: this.item,
            }
        },
        watch: {
            item(value) {
                this.itemData = value;
            }
        },
    }
</script>

<style lang="scss">
    .app-action {
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 27px;
        width: 80px;

        .app-action-btn {
            display: none !important;
        }

        &:hover {
            .md-icon {
                display: none;
            }

            .app-action-btn {
                display: inline-block !important;
                width: auto !important;
            }
        }
    }
</style>
